module.exports = __webpack_public_path__ + "img/LADY HAT PURPLE.d994bca.svg";